const getTaskSummaryResponse = (response) => {
  return response?.data;
};

export default getTaskSummaryResponse;
